import { useParams } from "react-router-dom";
import useFetch from "../../../clients/features/get";
import HotelHeader from "./HotelHeader";
import HotelInfo from "./HotelInfo";
import PhotosManager from "./PhotosManager";
import EquipmentsManager from "./EquipmentsManager";
import './HotelSettings.css'

export default function Dashboard() {

  const { hotelId } = useParams();
  const { data, loading, refreshData } = useFetch(
    `https://api.komorotel.com/api/hotels/find/${hotelId}`
  );

  if (loading) return <div className="modern-loader" />;

  return (
    <div className="dashboard-container">

      <HotelHeader data={data} refreshData={refreshData}/>

      <div className="dashboard-grid">
        <HotelInfo data={data} refreshData={refreshData} />
        <PhotosManager data={data} hotelId= {hotelId} refreshData={refreshData} />
      </div>

      <EquipmentsManager data={data} hotelId={hotelId} refreshData={refreshData} />

    </div>
  );
}